// extracted by mini-css-extract-plugin
export default {"errorPage":"AuthProvider_errorPage__dO+2+"};